const safeListItems = require('./src/safeList.ts');

const color = {
    text: {
        default: `var(--ehi-color-text)`,
        primary: `var(--ehi-color-text-primary)`,
        'primary-dark': `var(--ehi-color-text-primary-dark)`,
        error: `var(--ehi-color-text-error)`,
        inactive: `var(--ehi-color-text-inactive)`,
        link: `var(--ehi-color-link)`,
        'link-visited': `var(--ehi-color-link-visited)`,
        'icon-primary': `var(--ehi-color-icon-primary)`,
        'icon-secondary': `var(--ehi-color-icon-secondary)`,
        'icon-warning': `var(--ehi-color-icon-warning)`,
        'icon-alert': `var(--ehi-color-icon-alert)`,
        'icon-info': `var(--ehi-color-icon-info)`,
        comms: `var(--ehi-color-text-comms)`,
        accent: `var(--ehi-color-background-interactive-action)`,
    },
    border: {
        primary: `var(--ehi-color-border-primary)`,
        'primary-light': `var(--ehi-color-border-primary-light)`,
        enabled: `var(--ehi-color-border-enabled)`,
        error: `var(--ehi-color-border-error)`,
    },
    background: {
        'surface-primary': `var(--ehi-color-background-surface-primary)`,
        'surface-primary-darker': `var(--ehi-color-background-surface-primary-darker)`,
        'surface-highlight': `var(--ehi-color-background-surface-highlight)`,
        'surface-light': `var(--ehi-color-background-surface-light)`,
        'surface-dark': `var(--ehi-color-background-surface-dark)`,
        'surface-400': `var(--ehi-color-background-surface-400)`,
        'surface-300': `var(--ehi-color-background-surface-300)`,
        'surface-200': `var(--ehi-color-background-surface-200)`,
        'surface-100': `var(--ehi-color-background-surface-100)`,
        'surface-50': `var(--ehi-color-background-surface-50)`,
        'surface-0': `var(--ehi-color-background-surface-0)`,
        'interactive-action': `var(--ehi-color-background-interactive-action)`,
        'interactive-action-hover': `var(--ehi-color-background-interactive-action-hover)`,
        'interactive-primary': `var(--ehi-color-background-interactive-primary)`,
        'interactive-white': `var(--ehi-color-background-interactive-white)`,
        'interactive-focus': `var(--ehi-color-background-interactive-focus)`,
        'interactive-white-hover': `var(--ehi-color-background-interactive-white-hover)`,
        'interactive-dark': `var(--ehi-color-background-interactive-dark)`,
        'interactive-active': `var(--ehi-color-background-interactive-active)`,
        'interactive-error': `var(--ehi-color-background-interactive-error)`,
    },
    accent: {
        primary: `var(--ehi-color-background-surface-primary)`,
        highlight: `var(--ehi-color-background-surface-highlight)`,
    },
};

const templateGrid = (size) =>
    Array(10)
        .fill(1)
        .map((x, y) => {
            const col = x + y;
            return {
                [`${col}-${size}`]: `repeat(${col}, ${size})`,
            };
        })
        .reduce((acc, cur) => ({ ...acc, ...cur }), {});

module.exports = {
    content: [
        './src/**/*.{js,jsx,ts,tsx}',
        //'./node_modules/tofu-widgets/src/**/*.*',
        //'./node_modules/@medicare-tools/login-widget/src/**/*.{vue,ts}',
        //'./node_modules/@medicare-tools/stepper/src/**/*.{vue,ts}',
    ],
    safelist: safeListItems,
    theme: {
        extend: {
            animation: {
                'fade-in': 'fade-in 0.7s cubic-bezier(0.694, 0, 0.335, 1) forwards',
            },
            dropShadow: {
                'elevation-shadow-overlay': '0 4px 20px rgba(0, 0, 0, 0.16)',
            },
            borderWidth: {
                16: '16px',
            },
            boxShadow: {
                '3xl': 'rgba(0, 0, 0, 0.25) 0px 4px 4px 0px',
            },
            fontSize: {
                12: '0.75rem',
                14: '0.875rem',
                16: '1rem',
                18: '1.125rem',
                20: '1.25rem',
                22: '1.375rem',
                24: '1.5rem',
                28: '1.75rem',
                32: '2rem',
                34: '2.125rem',
                40: '2.5rem',
                48: '3rem',
                56: '3.5rem',
                64: '4rem',
                90: '5.625rem',
            },
            gridTemplateColumns: {
                ...templateGrid('auto'),
                ...templateGrid('min-content'),
                'auto-fit': 'repeat(auto-fit, minmax(0, 1fr))',
                'auto-fill': 'repeat(auto-fill, minmax(0, 1fr))',
            },
            gridTemplateRows: {
                ...templateGrid('auto'),
                ...templateGrid('min-content'),
                'auto-fit': 'repeat(auto-fit, minmax(0, 1fr))',
                'auto-fill': 'repeat(auto-fill, minmax(0, 1fr))',
            },
            keyframes: {
                'fade-in': {
                    '0%': { opacity: 0 },
                    '100%': { opacity: 1 },
                },
            },
            lineHeight: {
                65: '4.0625rem',
                64: '4rem',
                62: '3.875rem',
                60: '3.75rem',
                56: '3.5rem',
                52: '3.25rem',
                48: '3rem',
                46: '2.875rem',
                42: '2.625rem',
                40: '2.5rem',
                38: '2.375rem',
                36: '2.25rem',
                32: '2rem',
                28: '1.75rem',
                27: '1.6875rem',
                26: '1.625rem',
                24: '1.5rem',
                22: '1.375rem',
                21: '1.3125rem',
                20: '1.25rem',
                18: '1.125rem',
                16: '1rem',
            },
            screens: {
                xs: '320px',
                ss: '350px',
                sm: '576px',
                md: '768px',
                lg: '992px',
                xl: '1200px',
                ipadpro: '1025px',
                print: { raw: 'print' },
                benefits: '1224px',
            },
        },
        fontFamily: {
            sans: '"Open Sans", sans-serif',
            poppins: 'Poppins',
            roboto: 'Roboto',
        },
        minHeight: (theme) => ({
            0: '0px',
            ...theme('spacing'),
            full: '100%',
            screen: '100vh',
        }),
        minWidth: (theme, { breakpoints }) => ({
            0: '0px',
            ...theme('spacing'),
            ...breakpoints(theme('screens')),
            full: '100%',
            min: 'min-content',
            max: 'max-content',
        }),
        maxHeight: (theme) => ({
            0: '0px',
            ...theme('spacing'),
            full: '100%',
            screen: '100vh',
        }),
        maxWidth: (theme, { breakpoints }) => ({
            0: '0px',
            1200: '1200px',
            ...theme('spacing'),
            ...breakpoints(theme('screens')),
            full: '100%',
            min: 'min-content',
            max: 'max-content',
        }),
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            black: '#000000',
            cyan: '#16B2B0',
            blue: {
                dark: '#000060',
                DEFAULT: '#3A5EBA',
                light: '#E9F1F4',
                lightest: '#E5F5FB',
                baby: '#EEF2F2',
                sky: '#8DBDCD',
                disabled: '#',
                link: '#B0BFE3',
                lightsky: '#F2F7F8',
                pale: '#D6E0EF',
                paler: '#E0E8F2',
            },
            gray: {
                dark: '#333333',
                DEFAULT: '#767676',
                light: '#EEEEEE',
                lightest: '#F8F8F8',
                accessible: '#666666',
                disabled: '#999999',
                outline: '#CCCCCC',
                hr: '#C7C7C7',
                signIn: '#F4F6FC',
                lighter: '#EEF2F2',
            },
            pink: {
                DEFAULT: '#F3CFC7',
                lightest: '#fff7f5',
            },
            orange: {
                DEFAULT: '#E65100',
                dark: '#E3740D',
                gold: '#FFAC31',
            },
            green: {
                dark: '#0E8A74',
                DEFAULT: '#14855E',
                light: '#1CA78E',
                lightest: '#F3FAE6',
                disabled: '#A9D2CB',
                underline: '#8CC63E',
                divider: '#D5E4D9',
                olive: '#E4EFE7',
                logo: '#73B81D',
            },
            red: {
                DEFAULT: '#CD1D2C',
                lighter: '#EB6651',
                lightest: '#FFF7F5',
                'email-error': '#FF6B72',
            },
            white: '#FFFFFF',
            yellow: {
                lightest: '#FFF9DA',
            },
            purple: {
                DEFAULT: '#6F52E2',
                light: '#E3DEF9',
            },
            secondary: {
                actionOrange: '#FA6200',
                canvasGrey: '#E9F0EA',
            },
            tertiary: {
                black: '#1F1F1F',
                alertPink: '#EB4CAC',
            },
            branded: {
                sutter: '#12ada0',
            },
            ...color.text,
            ...color.background,
            ...color.border,
            ...color.accentColor,
        },
    },
    plugins: [],
};
